import type { MenuModel } from "@/types";
import AppSubMenu from "./AppSubMenu";

const AppMenu = () => {
    const model: MenuModel[] = [
        {
            label: "PLACES",
            icon: "pi pi-map", // Map icon for places
            items: [
                {
                    label: "PROVINCES",
                    icon: "pi pi-globe", // Globe icon for provinces/regions
                    to: "/admin/provinces"
                },
                {
                    label: "LOCAL AUTHORITIES",
                    icon: "pi pi-building", // Building icon for authorities
                    to: "/admin/localAuthorities"
                },
                {
                    label: "RESERVOIR ZONES",
                    icon: "pi pi-compass", // Compass icon for zones/areas
                    to: "/admin/reservoirZones"
                },
                {
                    label: "DMAS",
                    icon: "pi pi-sliders-h", // Sliders icon for metered/controlled areas
                    to: "/admin/districtMeteredAreas"
                },
                {
                    label: "SUBURB",
                    icon: "pi pi-map", // Sliders icon for metered/controlled areas
                    to: "/admin/suburbs"
                },
            ],
        },
    ];

    return <AppSubMenu model={model} />;
};

export default AppMenu;
